import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './style/addonicon.scss';
import addOnIcons from './../../../../style/addonicons/addonicons.scss'; // eslint-disable-line

class AddOnIcon extends Component {
    render() {
        const { handle } = this.props;

        if (!handle) {
            return null;
        }

        return <div className={ `${style.icon_addon} ${style[handle]}` }>
            <figure><i className={ `${addOnIcons.icon} ${addOnIcons[handle]}` } /></figure>
        </div>;
    }
}

export default AddOnIcon;

AddOnIcon.propTypes = {
    handle: PropTypes.string
};
